import PropTypes from 'prop-types';
import clsx from 'clsx';
import classes from './block.module.css';

const Block = (props) => {
  const {
    avatar,
    onClick,
    href,
    target = '_blank',
    title,
    children,
    loading = false, // usage only on button (onClick)
  } = props;

  const buttonClick = () => {
    if (!loading) {
      onClick();
    }
  };

  const avatarElement = avatar ? <div className={classes.avatar}>{avatar}</div> : null;
  const bodyElement = <div className={classes.body}>
    {title && <div className={classes.title}>{title}</div>}
    <div className={classes.contents}>{children}</div>
  </div>;
  let blockElement = <div className={classes.block}>{avatarElement}{bodyElement}</div>;

  if (onClick) {
    const classNames = clsx(classes.block, classes.click, loading && classes.loading);
    blockElement = <button className={classNames} onClick={buttonClick}>
      {avatarElement}
      {bodyElement}
    </button>;
  } else if (href) {
    blockElement = <a className={classes.block} href={href} target={target}>
      {avatarElement}
      {bodyElement}
    </a>;
  }

  return blockElement;
};

Block.propTypes = {
  avatar: PropTypes.node,
  onClick: PropTypes.func,
  href: PropTypes.string,
  target: PropTypes.oneOf(['_self', '_blank']),
  title: PropTypes.string,
  children: PropTypes.any,
  loading: PropTypes.bool,
};

export default Block;
